import { FC, Suspense, useCallback, useEffect } from 'react';
import styled from '@emotion/styled';
import { useAtom, useSetAtom } from 'jotai';
import LoginModal from 'src/components/LoginModal';
import Payments from 'src/components/Payments';
import { CheckoutSkeleton } from 'src/components/Payments/Skeleton';
import { RootStyle } from 'src/components/Payments/style';
import useLogin from 'src/hooks/useLogin';
import useOneTimeMessageListener from 'src/hooks/useOneTimeMessageListener';
import { showModalAtom } from 'src/stores/modal/atoms';
import { paymentsErrorAtom, paymentsReservationAtom, paymentPopupInfoAtom, productToPurchaseAtom } from 'src/stores/payments/atoms';
import { PaymentPopupInfoMessage, PaymentsReservationMessage, WindowMessageType } from 'src/types/message';
import { ModalType } from 'src/types/Modal';
export const ImgGemSquare = styled.img`
  width: 20px;
  height: 20px;
  ${({
  theme
}) => theme.isRtl ? 'margin-left' : 'margin-right'}: 5px;
`;
const PaymentView: FC = () => {
  const showModal = useSetAtom(showModalAtom);
  const [paymentPopupInfo, setPaymentPopupInfo] = useAtom(paymentPopupInfoAtom);
  const setProductToPurchase = useSetAtom(productToPurchaseAtom);
  const setReservation = useSetAtom(paymentsReservationAtom);
  const setError = useSetAtom(paymentsErrorAtom);
  const {
    isLogin
  } = useLogin();
  useEffect(() => {
    if (!isLogin) {
      showModal({
        key: ModalType.LOGIN,
        component: LoginModal
      });
    }
  }, [isLogin, showModal]);
  const initializePaymentPopupInfo = useCallback(({
    paymentPopupInfo: popupInfo
  }: PaymentPopupInfoMessage) => {
    setProductToPurchase(popupInfo.product);
    setPaymentPopupInfo(popupInfo);
  }, [setPaymentPopupInfo, setProductToPurchase]);
  const handleReservation = useCallback(({
    reservation,
    errorCode
  }: PaymentsReservationMessage) => {
    if (reservation) {
      setReservation(reservation);
    } else if (errorCode) {
      setError({
        errorCode
      });
    }
  }, [setReservation, setError]);
  useOneTimeMessageListener(WindowMessageType.PaymentPopupInfo, initializePaymentPopupInfo);
  useOneTimeMessageListener(WindowMessageType.PaymentsReservation, handleReservation);
  if (!isLogin || !paymentPopupInfo) {
    return <RootStyle>
        <CheckoutSkeleton />
      </RootStyle>;
  }
  return <Suspense fallback={<RootStyle>
          <CheckoutSkeleton />
        </RootStyle>} data-sentry-element="Suspense" data-sentry-component="PaymentView" data-sentry-source-file="Payment.tsx">
      <Payments data-sentry-element="Payments" data-sentry-source-file="Payment.tsx" />
    </Suspense>;
};
export default PaymentView;